import Cotizacion from "./cotizaciones.component.js";

export default function Cotizaciones() {
  return (
    <div>      
      <h2>Cotizaciones</h2>
      <Cotizacion />
    </div>
  );
}